import { Heading } from '@findy-code/yuffie/ui/heading';
import { GoRepoForked, GoStar } from 'react-icons/go';

import styles from './company-detail-github.component.module.scss';
import { SectionLayout } from './section-layout.component';

interface GithubRepositoryType {
  id: number;
  name: string;
  description?: string | null;
  skillType: string;
  starsCount: number;
  forksCount: number;
}

type Props = {
  companyName: string;
  githubAccount?: string | null;
  githubRepositories: GithubRepositoryType[];
  githubMemberCount: number;
};

export const CompanyDetailGithub = ({
  companyName,
  githubAccount,
  githubRepositories,
  githubMemberCount,
}: Props) => {
  return (
    <SectionLayout heading={{ title: '公式GitHub' }} id="git-hub">
      <div className={styles.githubBlock}>
        <div className={styles.githubHeader}>
          <div className={styles.githubCompany}>
            <div className={styles.githubLogo}>
              <img
                alt={`${companyName}ロゴ`}
                height="60"
                src={`https://avatars.githubusercontent.com/${githubAccount}`}
                width="60"
              />
            </div>
            <div>
              <Heading as="h4" font="heading-xl">
                {companyName}
              </Heading>
              <a
                className={styles.githubAnchor}
                href={`https://github.com/${githubAccount}`}
                rel="noopener"
                target="_blank"
              >
                https://github.com/{githubAccount}
              </a>
            </div>
          </div>
          <div className={styles.githubOverview}>
            <div className={styles.githubOverviewItem}>
              <span>Repositories</span>
              <span className={styles.githubOverviewTag}>
                {githubRepositories.length}
              </span>
            </div>
            <div className={styles.githubOverviewItem}>
              <span>People</span>
              <span className={styles.githubOverviewTag}>
                {githubMemberCount}
              </span>
            </div>
          </div>
        </div>
        {githubRepositories && githubRepositories.length > 0 && (
          <div className={styles.repositoryBlock}>
            <div className={styles.repositoryGrid}>
              {githubRepositories.map((repository) => (
                <div className={styles.repositoryItem} key={repository.id}>
                  <div>
                    <a
                      className={styles.repositoryAnchor}
                      href={`https://github.com/${repository.name}`}
                      rel="noopener"
                      target="_blank"
                    >
                      {repository.name}
                    </a>
                    <div className={styles.repositoryDescription}>
                      {repository.description}
                    </div>
                  </div>
                  <div className={styles.repositoryMeta}>
                    <span className={styles.repositoryMetaItem}>
                      <span>{repository.skillType}</span>
                    </span>
                    <span className={styles.repositoryMetaItem}>
                      <GoStar aria-hidden="true" size="14px" />
                      <span>{repository.starsCount}</span>
                    </span>
                    <span className={styles.repositoryMetaItem}>
                      <GoRepoForked aria-hidden="true" size="14px" />
                      <span>{repository.forksCount}</span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </SectionLayout>
  );
};
